import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

import { AuthService } from '@app/api/api-services/auth.service';
import { RouteHelperService } from '../route-helper.service';
import { RedirectService } from '../redirect.service';

@Injectable()
export class RedirectGuard implements CanActivate {
  constructor(
    private readonly authService: AuthService,
    private readonly routeHelper: RouteHelperService,
    private readonly redirectService: RedirectService
  ) {}

  public canActivate(): boolean {
    if (this.authService.isAuthenticated()) {
      this.redirectService.redirectToDefault();
    } else {
      this.routeHelper.login();
    }

    return false;
  }
}
